const itemsObj = {
  "bed": {
    "stepNum": 0,
    "alias": "bed",
    "name": "bed",
    "showTypes": false,
    "template": "grid",
    "types": {
      "bed": {
        "name": "bed",
        "subTypes": ["bed"]
      }
    }
  },
  "bedCover": {
    "stepNum": 4,
    "alias": "bedCover",
    "name": "bed cover",
    "showTypes": true,
    "removable": true,
    "template": "list",
    "types": {
      "bedCover": {
        "name": "bed cover",
        "subTypes": ["jacquardBlue", "timelessBlue"]
      },
      "lightQuilt": {
        "name": "light quilt",
        "subTypes": ["jacquardOrange", "fashionGreen", "embroideryYellow"]
      }
    }
  },
  "bedHeadboardFinishing": {
    "stepNum": 0,
    "alias": "bedHeadboardFinishing",
    "name": "bed headboard finishing",
    "showTypes": false,
    "template": "list",
    "types": {
      "bedHeadboardFinishing": {
        "name": "bed headboard finishing",
        "subTypes": ["ecoNabuk", "vintageEcoLeather", "fabric"]
      }
    }
  },
  "bedFrame": {
    "stepNum": 0,
    "alias": "bedFrame",
    "name": "frame",
    "showTypes": false,
    "template": "list",
    "types": {
      "bedFrame": {
        "name": "frame",
        "subTypes": ["wooden"]
      }
    }
  },
  "bedSet": {
    "stepNum": 0,
    "alias": "bedSet",
    "name": "bed set",
    "showTypes": true,
    "template": "list",
    "link": {
      "prop": "type",
      "toStep": "duvetCover",
      "toSubStep": "duvetCover"
    },
    "types": {
      "fold": {
        "name": "fold",
        "subTypes": [
          "embroideryBrown",
          "embroideryRed",
          "timelessMagenta",
          "fashionGreen"
        ]
      },
      "open": {
        "name": "open",
        "subTypes": [
          "embroideryBrown",
          "embroideryRed",
          "timelessMagenta",
          "fashionGreen"
        ]
      }
    }
  },
  "duvetCover": {
    "stepNum": 3,
    "alias": "duvetCover",
    "name": "duvet cover",
    "showTypes": true,
    "template": "list",
    "link": {
      "prop": "type",
      "toStep": "bedSet",
      "toSubStep": "bedSet"
    },
    "types": {
      "fold": {
        "name": "fold",
        "subTypes": [
          "fashionGreen",
          "timelessMagenta",
          "jacquardOrange",
          "embroideryRed",
          "embroideryBrown"
        ]
      },
      "open": {
        "name": "open",
        "subTypes": [
          "fashionGreen",
          "timelessMagenta",
          "jacquardOrange",
          "embroideryRed",
          "embroideryBrown"
        ]
      }
    }
  },
  "environment": {
    "stepNum": 5,
    "alias": "environment",
    "name": "environment",
    "showTypes": true,
    "template": "list",
    "types": {
      "withBoiserie": {
        "name": "with boiserie",
        "subTypes": ["environment"]
      },
      "withoutBoiserie": {
        "name": "without boiserie",
        "subTypes": ["environment"]
      }
    }
  },
  "pillowSquare": {
    "stepNum": 1,
    "alias": "pillowSquare",
    "name": "square pillow",
    "showTypes": true,
    "template": "list",
    "defaultImg": "pillowSquareDefault",
    "types": {
      "sham": {
        "name": "sham",
        "subTypes": ["timelessMagenta", "jacquardOrange", "fashionGreen"]
      },
      "case": {
        "name": "case",
        "subTypes": [
          "timelessBlue",
          "jacquardBlue",
          "embroideryRed",
          "embroideryBrown"
        ]
      }
    }
  },
  "pillowRectangular": {
    "stepNum": 1,
    "alias": "pillowRectangular",
    "name": "rectangular pillow",
    "showTypes": true,
    "defaultImg": "pillowRectangularDefault",
    "template": "list",
    "types": {
      "sham": {
        "name": "sham",
        "subTypes": ["fashionGreen", "jacquardOrange", "timelessMagenta"]
      },
      "case": {
        "name": "case",
        "subTypes": ["embroideryBrown", "embroideryRed"]
      }
    }
  },
  "pillowRectangularB": {
    "stepNum": 1,
    "alias": "pillowRectangularB",
    "name": "rectangular pillow b",
    "showTypes": true,
    "defaultImg": "pillowRectangularBDefault",
    "template": "list",
    "types": {
      "sham": {
        "name": "sham",
        "subTypes": ["fashionGreen", "jacquardOrange", "timelessMagenta"]
      },
      "case": {
        "name": "case",
        "subTypes": ["embroideryBrown", "embroideryRed"]
      }
    }
  },
  "pillowDecorative": {
    "stepNum": 1,
    "alias": "pillowDecorative",
    "name": "decorative pillow",
    "showTypes": false,
    "template": "list",
    "defaultImg": "pillowDecorativeDefault",
    "types": {
      "pillowDecorative": {
        "name": "decorative pillow",
        "subTypes": ["jacquardBlue", "embroideryPurple", "timelessBlue"]
      }
    }
  }
}

export default itemsObj
